<template>
  <div class="user">
    <div class="photo">
      <img :src="userAvatar">
    </div>
    <div class="info">
      <a
        data-toggle="collapse"
        href="javascript:void(0)"
        @click="toggleMenu"
      >
        <span
          class="info-username"
          :title="user.fullName"
        >
          {{ user.fullName }}
          <b class="caret" />
        </span>
      </a>
      <div class="clearfix" />
      <div>
        <el-collapse-transition>
          <ul
            v-show="!isClosed"
            class="nav custom-menu"
            @click="toggleSidebar"
          >
            <acl :permissions="['profile_show']">
              <li
                data-active-color="info"
                :class="{ active: onProfilePage }"
              >
                <router-link :to="{ name: 'users@profile' }">
                  <span class="sidebar-mini"><i class="far fa-id-badge" /></span>
                  <span class="sidebar-normal">My Profile</span>
                </router-link>
              </li>
            </acl>
            <li>
              <router-link :to="{ name: 'system@logout' }">
                <span class="sidebar-mini"><i class="far fa-power-off" /></span>
                <span class="sidebar-normal">Logout</span>
              </router-link>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import { mapGetters } from "vuex";
import createAvatar from "@helpers/createAvatar";

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition
  },
  data() {
    return {
      isClosed: true
    };
  },
  computed: {
    ...mapGetters("userStore", ["user"]),
    userAvatar() {
      return (
        this.user.avatar ||
        createAvatar({
          imgElement: this.$refs.avatar,
          fullName: this.user.fullName,
          size: 30,
          fontSize: 12
        })
      );
    },
    onProfilePage() {
      return this.$route.name.match("users@profile");
    }
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}

.info-username {
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 15px;
}
</style>
